module.exports = __webpack_public_path__ + "img/icon2_1.7a051031.png";